import { useEffect, useRef } from 'react';
import api from 'api';

interface Props {
  enabled: boolean;
}

const useUpdateSession = ({ enabled }: Props) => {
  const sessionUpdateTimeout = useRef<NodeJS.Timeout>(undefined);

  useEffect(() => {
    return () => {
      window.removeEventListener('mousemove', handleUserActivity);
      window.removeEventListener('keydown', handleUserActivity);
      window.removeEventListener('scroll', handleUserActivity);
    };
  }, []);

  useEffect(() => {
    if (enabled) {
      window.addEventListener('mousemove', handleUserActivity);
      window.addEventListener('keydown', handleUserActivity);
      window.addEventListener('scroll', handleUserActivity);
    } else {
      window.removeEventListener('mousemove', handleUserActivity);
      window.removeEventListener('keydown', handleUserActivity);
      window.removeEventListener('scroll', handleUserActivity);
    }
  }, [enabled]);

  const handleUserActivity = () => {
    const fiveMinutesAgo = Date.now() - 300000;
    if (!api.lastCalledOn || fiveMinutesAgo > api.lastCalledOn) {
      // will send a ping request to the API to update the session if the user
      // has been active but no request has been made in the last five minutes
      clearTimeout(sessionUpdateTimeout.current);
      sessionUpdateTimeout.current = setTimeout(() => api.get('/ping'), 1000);
    }
  };

  return enabled;
};

export default useUpdateSession;
